<template lang="pug">
    v-container(grid-list-md v-if="billing")
        v-layout(wrap)
            v-flex(lg4 md4 xs12 v-if="billing && billing.status")
                v-text-field(dense v-model="billing.status" label="Status" readonly )
            v-flex(lg8 md8 xs12 v-if="billing && billing.errorMessage")
                v-text-field(dense v-model="billing.errorMessage" label="Keterangan" readonly )
        v-layout(wrap)
            v-flex(lg6 md6 xs12)
                v-layout(wrap)
                    v-flex(lg6 md6 xs12 v-if="map")
                        v-text-field(dense v-model="map" label="Kode Map" readonly )
                    //v-flex(lg6 md6 xs12 v-if="payType")
                    //    v-text-field(dense v-model="payType" label="Jenis Setoran" readonly )
                v-layout(wrap)
                    v-flex(lg6 md6 xs12 v-if="billing.npwp")
                        v-text-field(dense v-model="billing.npwp" label="NPWP" readonly )
                    v-flex(lg6 md6 xs12 v-if="billing.idWajibPajak")
                        v-text-field(dense v-model="billing.idWajibPajak" label="No. Identitas" readonly )
                v-layout(wrap)
                    v-flex(lg8 md8 xs12 v-if="billing.nama")
                        v-text-field(dense v-model="billing.nama" label="Nama Wajib Pajak" readonly )
                    v-flex(lg12 md12 xs12 v-if="billing.alamat")
                        v-text-field(dense v-model="billing.alamat" label="Alamat Wajib Pajak" readonly )
                    v-flex(lg6 md6 xs12 v-if="billing.kota")
                        v-text-field(dense v-model="billing.kota" label="Kota Wajib Pajak" readonly )
                    v-flex(lg4 md4 xs12 v-if="billing.jumlahDetail")
                        v-text-field(dense v-model="billing.jumlahDetail" label="Jumlah Detail" readonly)
            v-flex(lg6 md6 xs12)
                v-layout(wrap)
                    v-flex(lg4 md4 xs12 v-if="billing.periode1")
                        f-select-month(dense v-model="billing.periode1" label="Masa Pajak Awal" readonly )
                    v-flex(lg4 md4 xs12 v-if="billing.periode2")
                        f-select-month(dense v-model="billing.periode2" label="Masa Pajak Akhir" readonly )
                    v-flex(lg4 md4 xs12 v-if="billing.tahun")
                        v-text-field(dense v-model="billing.tahun" label="Tahun" readonly )
                v-layout(wrap)
                    v-flex(lg6 md6 xs12 v-if="billing.noKetetapan")
                        v-text-field(dense v-model="billing.noKetetapan" label="No Ketetapan" readonly )
                    v-flex(lg6 md6 xs12 v-if="billing.kodePemda")
                      v-text-field(dense v-model="billing.kodePemda" label="Kode Pemda" readonly )
                    v-flex(lg6 md6 xs12 v-if="billing.nop")
                        v-text-field(dense v-model="billing.nop" label="NOP" readonly )
                v-layout(wrap)
                    v-flex(lg12 md12 xs12 v-if="billing.namaSetor")
                        v-text-field(dense v-model="billing.namaSetor" label="Nama Penyetor" readonly )
                    v-flex(lg6 md6 xs12 v-if="billing.npwpSetor")
                        v-text-field(dense v-model="billing.npwpSetor" label="NPWP Penyetor" readonly )
                    v-flex(lg6 md6 xs12)
                        f-decimalbox(v-model="billing.amount" label="Nominal" readonly)
                v-layout(wrap)
                    v-flex(lg4 md4 xs12 v-if="billing.billNumber")
                        v-text-field(dense v-model="billing.billNumber" label="Kode Billing" readonly )
                    v-flex(lg4 md4 xs12 v-if="billing.ntpn")
                        v-text-field(dense v-model="billing.ntpn" label="NTPN" readonly )
                    v-flex(lg4 md4 xs12 v-if="billing.expiredDate")
                        v-text-field(dense v-model="billing.expiredDate" label="Tanggal Kadaluarsa" readonly )
            v-layout(wrap)
                v-flex(lg11 md12 xs12 v-if="billing.uraian")
                    v-text-field(dense v-model="billing.uraian"  label="Uraian" readonly )
        div(justify-center style="text-align: center;" class="ma-2 menu-btn")
            v-btn(class="mx-1" @click="doBack") Kembali
                v-icon mdi-arrow-left-circle
</template>
<script>
export default {
    name: "FBillingContent",
    props: ["billingData"],
    data() {
        return {
            billing: null
        }
    },
    watch: {
        billingData(val){
            this.doInit(val);
        }
    },
    computed: {
        map(){
            return this.billing.mapTransaction ? (this.billing.mapTransaction + (this.billing.additionalData.map ?
                (this.billing.additionalData.map.description ?
                    (" - " + this.billing.additionalData.map.description) : "") : "")) : "" ;
        },
        payType(){
            return this.billing.jenisSetor ? (this.billing.jenisSetor + (this.billing.additionalData.payType ?
                (this.billing.additionalData.payType.description ?
                    (" - " + this.billing.additionalData.payType.description) : "") : "")) : "";
        }
    },
    mounted() {
        this.doInit(this.billingData);
    },
    methods: {
        doInit(values){
            this.billing = values ? values : null;
        },
        doBack(){
            this.$emit("back");
        }
    },
}
</script>